import { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { SectionCard, SectionTitle, SubmitButton, CancelButton, ButtonsRow } from './Formstyle';
import { TextField, Stack } from '@mui/material';
import SelectTopics from '../../../components/SelectTopics';
import CityStateSelect from '../../../components/CityStateSelect';

const validationSchema = Yup.object().shape({
    description: Yup.string().max(250, 'Máximo 250 caracteres'),
    profession: Yup.string().max(150, 'Máximo 150 caracteres'),
    education: Yup.string().max(150, 'Máximo 150 caracteres'),
    instagram: Yup.string().max(150, 'Máximo 150 caracteres'),
});

const ExtraInfo = ({ user, submit }) => {
    const [editing, setEditing] = useState(false);

    const formik = useFormik({
        initialValues: {
            description: user?.description || '',
            profession: user?.profession || '',
            education: user?.education || '',
            residence: user?.residence || '',
            instagram: user?.instagram || '',
            topics: user?.topics?.map(t => t.topic_id || t) || [],
        },
        validationSchema,
        onSubmit: (values) => {
            submit(values);
            setEditing(false);
        },
    });

    useEffect(() => {
        if (user) {
            formik.setValues({
                description: user.description || '',
                profession: user.profession || '',
                education: user.education || '',
                residence: user.residence || '',
                instagram: user.instagram || '',
                topics: user.topics?.map(t => t.topic_id || t) || [],
            });
        }
    }, [user]);

    const handleCancel = () => {
        formik.resetForm();
        setEditing(false);
    };

    const handleFieldClick = () => {
        if (!editing) setEditing(true);
    };

    return (
        <SectionCard>
            <SectionTitle>Dados Profissionais</SectionTitle>
            <Stack spacing={2}>
                <SelectTopics
                    value={formik.values.topics}
                    name="topics"
                    onChange={(name, value) => {
                        formik.setFieldValue('topics', value);
                        if (!editing) setEditing(true);
                    }}
                    disabled={!editing}
                />
                <TextField
                    label="Profissão"
                    name="profession"
                    size="small"
                    fullWidth
                    value={formik.values.profession}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onFocus={handleFieldClick}
                    disabled={!editing}
                    error={formik.touched.profession && Boolean(formik.errors.profession)}
                    helperText={formik.touched.profession && formik.errors.profession}
                />
                <TextField
                    label="Formação"
                    name="education"
                    size="small"
                    fullWidth
                    value={formik.values.education}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onFocus={handleFieldClick}
                    disabled={!editing}
                    error={formik.touched.education && Boolean(formik.errors.education)}
                    helperText={formik.touched.education && formik.errors.education}
                />
                <CityStateSelect
                    value={formik.values.residence}
                    onChange={(name, val) => {
                        formik.setFieldValue(name, val);
                        if (!editing) setEditing(true);
                    }}
                    name="residence"
                    disabled={!editing}
                />
                <TextField
                    label="Instagram"
                    name="instagram"
                    size="small"
                    fullWidth
                    value={formik.values.instagram}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onFocus={handleFieldClick}
                    disabled={!editing}
                    error={formik.touched.instagram && Boolean(formik.errors.instagram)}
                    helperText={formik.touched.instagram && formik.errors.instagram}
                />
                <TextField
                    label="Sobre você"
                    name="description"
                    size="small"
                    fullWidth
                    multiline
                    minRows={3}
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onFocus={handleFieldClick}
                    disabled={!editing}
                    error={formik.touched.description && Boolean(formik.errors.description)}
                    helperText={formik.touched.description ? formik.errors.description : `${250 - (formik.values.description?.length || 0)} caracteres restantes`}
                    inputProps={{ maxLength: 250 }}
                />
            </Stack>
            <ButtonsRow>
                <CancelButton type="button" $visible={editing} onClick={handleCancel}>
                    Cancelar
                </CancelButton>
                <SubmitButton type="button" $visible={editing} onClick={formik.handleSubmit}>
                    Salvar
                </SubmitButton>
            </ButtonsRow>
            {!editing && (
                <SubmitButton
                    type="button"
                    $visible={true}
                    onClick={() => setEditing(true)}
                    style={{ marginTop: 12, background: 'transparent', color: '#006a61', border: '1.5px solid #006a61' }}
                >
                    Editar dados
                </SubmitButton>
            )}
        </SectionCard>
    );
};

export default ExtraInfo;
